export const CHANGE_TYPE_BILLING_PERIOD = 'billingPeriod';
export const CHANGE_TYPE_PLAN = 'plan';
export const CHANGE_PLAN_DIALOG_NAME = 'changePlanDialog';
export const EDIT_PAID_FEATURES_DIALOG_NAME = 'editPaidFeaturesDialog';
// these paid features consts should be the same as in PaidFeature table in DB, column displayName
export const BACKGROUND_REMOVAL = 'Image background removal';
export const FOOTER_REMOVAL = "CrazyLister's footer removal";
export const INVENTORY_SYNC = 'Inventory sync';
import * as _ from 'lodash';

export const BILLING_PERIOD = {
  MONTH: 1,
  YEAR: 2,
};

export const PAYMENT_SUCCESS_TYPE = {
  BILLING_PERIOD: 'billingPeriod',
  PLAN: 'plan',
  RETRY: 'retry',
};

// this should be as defined in PlansProfile::NEW_PLANS_GENERATION
export const NEW_PLANS_GENERATION = 2;

export const getPrice = _.memoize((displayName, paidFeaturesData) => _.get(paidFeaturesData, `${displayName}.price`));
export const getPriceText = (name, paidFeaturesData, billingPeriod) =>
  `US $${getPrice(name, paidFeaturesData)} / ${billingPeriod === BILLING_PERIOD.MONTH ? 'Month' : 'Year'}`;
export const getPlanText = (name, price, billingPeriod) =>
  `${name}: US $${price} ${billingPeriod === BILLING_PERIOD.MONTH ? 'month to month' : 'x 12 months'}`;
export const hasStockSyncEnabledSeller = (ebayAccounts, amazonAccounts) =>
  _.some({...ebayAccounts, ...amazonAccounts}, ({quantitySyncEnabled}) => !!quantitySyncEnabled);
